/* eslint-disable import/prefer-default-export */
import { BitmapLayer } from '@deck.gl/layers';
import { TileLayer } from '@deck.gl/geo-layers';
import { format } from 'util';
import { Layer as FulcrumLayer } from '../../../models/layer';
import { App } from '../../../hooks/use-app';

export const TILE_SIZE = 256;

const fulcrumPNGLayer = (layer: FulcrumLayer, baseUrl = '', token?: any) => format(
  '%s/tile/%s/%s/{z}/{x}/{y}@2x.png?%supdated=%s',
  baseUrl,
  token || '-',
  // @ts-ignore
  layer.source || layer.form,
  layer.filter ? `${new URLSearchParams({ q: layer.filter }).toString()}&` : '',
  layer.updated_at ? layer.updated_at.toISOString() : 'null',
);

export const convertFulcrumTileToMapLayer = (fulcrumLayer: FulcrumLayer, app: App): TileLayer => {
  let url;
  try {
    url = fulcrumPNGLayer(fulcrumLayer, app.layerSettings.tileURL, app.api.token);
  } catch (err) {
    throw new Error(`Invalid source for layer: ${fulcrumLayer.name}`);
  }

  return new TileLayer({
    id: fulcrumLayer.id,
    data: url,
    minZoom: 0,
    maxZoom: 22,
    tileSize: 256,
    updateTriggers: {},
    renderSubLayers: (props: any) => {
      const {
        bbox: {
          west, south, east, north,
        },
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north],
      });
    },
  });
};
